"use client";
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';
import NewsletterForm from './NewsletterForm';

const ContentHero = props => {
    const {eyebrow, headline, copy, image, cta, showNewsletter, pageSettings, patternSelect} = props || {};
    const {colorScheme} = pageSettings || {};

    const renderEyebrow = () => {
        if (!eyebrow) return null;

        return (
            <p className={`${styles.contentHero__eyebrow} ${colorScheme ? colorScheme[0] : ''}`}>
                {eyebrow}
            </p>
        );
    };

    const renderNewsletter = () => {
        return (
            <NewsletterForm colorScheme={colorScheme?.length > 0 ? colorScheme[0] : null} portalId={`7299793`} formId={`1e51d015-780a-4105-bb9f-b8bbad61bab0`} />
        );
    };

    const renderHeadline = () => {
        if (!headline) return null;

        return (
            <h1 className={`${styles.contentHero__headline} ${colorScheme ? colorScheme[0] : ''}`}>
                {headline}
            </h1>
        );
    };

    const renderCopy = () => {
        if (!copy) return null;

        return (
            <div 
                className={`${styles.contentHero__copy} ${colorScheme ? colorScheme[0] : ''}`} 
                dangerouslySetInnerHTML={{__html: copy || ' ' }}
            />
        );
    };

    const renderMainImage = () => {
        const {mediaItemUrl, mediaDetails, altText} = image?.node || {};

        return (
            <div className={styles.contentHero__image}>
                <Image
                    loading={'eager'} 
                    priority
                    src={mediaItemUrl || '/content_hero_fallback.png'} 
                    width={mediaDetails?.width || 1400} 
                    height={mediaDetails?.height || 1400} 
                    alt={altText || headline}
                />
            </div>
        );
    };

    const renderCta = () => {
        if (!cta?.title) return null;
        const {title, url} = cta || {};

        return (
            <Link href={url || '#'} className={`${styles.contentHero__cta} button regular ${colorScheme ? colorScheme[0] : ''}`}>
                {title}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#D41050"/>
                </svg>
            </Link>
        );
    };

    const renderContent = () => {
        return (
            <div className={`${styles.contentHero__content} ${colorScheme ? colorScheme[0] : ''}`}>
                {renderEyebrow()}
                {renderHeadline()}
                {showNewsletter ? renderNewsletter() : (
                    <>
                        {renderCopy()}
                        {renderCta()}
                    </>
                )}
            </div>
        );
    };
    
    return (
        <section className={styles.contentHero}>
            <div 
                className={`
                    ${styles.contentHero__inner} 
                    ${(colorScheme && colorScheme[0] === "champion") ? 'random-grid-dark-fade-top-center' : 'random-grid-light-fade-top-center'}
                    ${colorScheme ? colorScheme[0] : ''}
                `}>
                <div className={styles.contentHero__container}>
                    {renderMainImage()}
                    {renderContent()}
                </div>
            </div>
        </section>
    );
};

export default ContentHero;
